import { z } from 'zod';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_SHARE_ASSET_AB = defineFcm('psf_share_asset_ab')
	.asJson(
		z.object({
			enabled: z.boolean().optional(),
			experimentName: z
				.string()
				.regex(/^[a-z][a-z0-9_]*[a-z0-9]$/)
				.optional(),
			petitionsConfig: z.record(z.string().regex(/^\d+$/), z.object({ variant_1: z.string().url() })).optional(),
		}),
	)
	.withDefault({ enabled: false, experimentName: undefined, petitionsConfig: undefined })
	.toConfig({
		owner: 'squad-platypus',
		scope: ['corgi-front-end', 'corgi-middle-end'],
		context: 'PSF share links (slide-up, /psf/share) and their link previews, for the petitions listed here only',
		description: `Gates the share asset A/B experiment. For each petition in petitionsConfig, the variant_1 arm's PSF
			share links carry an /sa/:experimentName/variant_1 path segment, and link-preview crawlers render that petition's
			variant_1 image as og:image. control keeps today's /bsv image. Use one experimentName per image, with the arms
			control and variant_1 in Experiment Manager (fake_control is optional and keeps today's image too).
			"enabled" gates new links and the treatment only: links already shared keep rendering their image while the
			petition stays in petitionsConfig and experimentName is unchanged. To switch the experiment off, set
			enabled: false rather than using Disable. Global only on purpose: share links and link-preview crawlers resolve
			the FCM with different locales and countries, so a regional row could make a link and its preview disagree.`,
		supportedGroups: { global: true },
		template: {
			enabled: true,
			experimentName: 'psf_share_asset_ab_example_v1',
			petitionsConfig: {
				'123': {
					variant_1: 'https://change-frontend-assets-demo.s3.us-west-2.amazonaws.com/platypus-test/example.jpg',
				},
			},
		},
	});
